module.exports = __webpack_public_path__ + "static/media/drap-d.86469f1c.mp3";